import type { IconName } from "@blueprintjs/icons";
import { ConfigApp } from "./app";
import type { ConfigEnvironment } from "./environment";

export type ConfigHeaderApplication = {
  key: ConfigApp;
  display: string;
  uri: string;
  icon: IconName;
};

export const CONFIG_HEADER_APPLICATIONS_BY_ENVIRONMENT: {
  [key in ConfigEnvironment]: ConfigHeaderApplication[];
} = {
  local: [
    {
      key: ConfigApp.admin,
      display: "Admin",
      uri: "http://localhost:3002",
      icon: "shield",
    },
    {
      key: ConfigApp.cms,
      display: "CMS",
      uri: "http://localhost:3001",
      icon: "application",
    },
  ],
  dev: [
    {
      key: ConfigApp.admin,
      display: "Admin",
      uri: "https://admin-dev.panoscape.app",
      icon: "shield",
    },
    {
      key: ConfigApp.cms,
      display: "CMS",
      uri: "https://cms-dev.panoscape.app",
      icon: "application",
    },
  ],
  prod: [
    {
      key: ConfigApp.admin,
      display: "Admin",
      uri: "https://admin.panoscape.app",
      icon: "shield",
    },
    {
      key: ConfigApp.cms,
      display: "CMS",
      uri: "https://setup.panoscape.app",
      icon: "application",
    },
  ],
};
